import axios from "axios";
export const state = {
    audits: [],
    save_status: false,
};
export const getters = {
    Audit: state => state.audits,
    SaveStatus: state => state.save_status,
};

export const mutations = {
    SET_AUDITS(state, newValue) {
        state.audits = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
};

export const actions = {
    //fetching all audits
    fetchAudits({ commit },payload) {
        commit('SET_SAVE_STATUS', false);
        axios.post('audits',payload).then(auditsz => {
            commit('SET_AUDITS', auditsz.data);
            console.log(auditsz.data);
        });
        commit('SET_SAVE_STATUS', false);
    }
};